import type { components } from "@/api/types";

import { apiGet, apiPost } from "./client";
import { clearToken, getToken, setToken } from "./token";

export type AdminPublic = components["schemas"]["AdminPublic"];
export type AdminRole = components["schemas"]["AdminRole"];

/**
 * Вход по логину и паролю.
 *
 * Ошибка наружу пробрасывается как есть: форме входа нужно показать текст
 * бэкенда («Неверный логин или пароль»), а не собственную догадку о том, что
 * именно не сошлось. Неверный логин, неверный пароль и запертая лимитом
 * попыток учётка отвечают одинаково намеренно, и фронт не должен эту
 * одинаковость расшивать обратно.
 */
export async function login(input: {
  login: string;
  password: string;
}): Promise<AdminPublic> {
  const result = await apiPost("/api/v1/admin/auth/login", { body: input });
  setToken(result.token);
  return result.admin;
}

export function me(): Promise<AdminPublic> {
  return apiGet("/api/v1/admin/auth/me");
}

export function isAuthenticated(): boolean {
  return getToken() !== null;
}

export function logout(): void {
  clearToken();
}
